import { Stage, Status, SurveyDifficultyLevel } from "../services/config/enum"
import TeamsDocument from "./teamsDocument"

export enum SurveyProvider {
  typeform = "typeform",
  qualtrics = "qualtrics",
}

export enum SurveyLinkMode {
  auto = "auto",
  manual = "manual",
  unlinked = "unlinked",
}

interface SurveyDocumentItem {
  isDefault: boolean
  lang: string
  title: string
  type: string
  parentId?: string
  formId: string
  formUrl: string
  webhookUrl?: string // Optional since it's generated on the server
  webhookSecret?: string // Optional since it's generated on the server
  linkMode: SurveyLinkMode
  updatedAt?: string
}

interface SurveyDocument {
  parentId: string
  items: SurveyDocumentItem[]
}

interface Survey {
  id: string
  provider: SurveyProvider
  stage: Stage
  status: Status
  handle: string
  teamId: string
  team: { id: string; document: { items: TeamsDocument[] } }
  projectId: string
  suspended?: boolean
  useSecret?: boolean
  storeResponses?: boolean
  skipCompletionPopup?: boolean
  hasSibling: boolean
  document: SurveyDocument
  createdAt: string
  updatedAt: string
  startsAt: string
  endsAt: string
  difficultyLevel?: SurveyDifficultyLevel
  isRepeatable?: boolean
  maxRepetitions?: number
  createdAtT: number
  updatedAtT: number
  startsAtT: number
  endsAtT: number
  lastUpdatedAt: string
}

export default Survey
